module.exports = __webpack_public_path__ + "img/type3_uncheck.ef8acad7.png";